import React, { useState } from 'react';


import InstagramIcon from 'assets/icon/icone-instagram-pink.svg';
import LinkIcon from 'assets/icon/icone link.svg';
import PhoneIcon from 'assets/icon/icone telefone.svg';
import GpsIcon from 'assets/icon/icone local.png';
import Author from 'services/profissionals/models/author-interface';


import { 
  Card, 
  CardContent, 
  ProfileSection, 
  InfoSection, 
  ContactInfo, 
  ContactItem,
  ReadBioButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  CloseButton
} from './style';

type Props = {
  professional: Author;
};

const CardProfessional: React.FC<Props> = ({ professional }) => {
  const { name, info, avatar_url, description } = professional;
  const [displayNumber, setDisplayNumber] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <Card>
        <CardContent>
          <ProfileSection>
            <img className="profile-image" src={avatar_url} alt={name} />
          </ProfileSection>
          
          <InfoSection>
            <h3 className="professional-name">{name}</h3>
            
            <div className="specialties">
              {info.specialty.length
                ? info.specialty.map((specialty, index, array) => (
                    <React.Fragment key={index}>
                      <span className="specialty">{specialty}</span>
                      {array.length !== index + 1 ? <span className="separator"> e </span> : null}
                    </React.Fragment>
                  ))
                : null}
            </div>

            <ContactInfo>
              <div className="location">
                <img src={GpsIcon} alt="localização" />
                <span>{info.city}</span>
              </div>

              {info.telephone && (
                <ContactItem
                  onClick={() => setDisplayNumber(!displayNumber)}
                >
                  <img src={PhoneIcon} alt="telefone" />
                  <span>{displayNumber ? info.telephone : 'Mostrar número'}</span>
                </ContactItem>
              )}

              {info.site && (
                <ContactItem 
                  as="a" 
                  href={info.site} 
                  target="_blank" 
                  rel="noreferrer"
                >
                  <img src={LinkIcon} alt="site" />
                  <span>Site</span>
                </ContactItem>
              )}

              {info.social_media && (
                <ContactItem 
                  as="a" 
                  href={info.social_media} 
                  target="_blank" 
                  rel="noreferrer"
                >
                  <img src={InstagramIcon} alt="instagram" />
                  <span>Instagram</span>
                </ContactItem>
              )}
            </ContactInfo>

            <ReadBioButton onClick={openModal}>
              Leia a biografia
            </ReadBioButton>
          </InfoSection>
        </CardContent>
      </Card>

      {modalOpen && (
        <ModalOverlay onClick={closeModal}>
          <Modal onClick={(e) => e.stopPropagation()}>
            <ModalContent>
              <ModalHeader>
                <div className="modal-profile-section">
                  <img src={avatar_url} alt={name} className="modal-profile-image" />
                  <div className="modal-info">
                    <h2>{name}</h2>
                    <div className="modal-specialties">
                      {info.specialty.map((specialty, index, array) => (
                        <React.Fragment key={index}>
                          <span>{specialty}</span>
                          {array.length !== index + 1 ? <span> e </span> : null}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
                <CloseButton onClick={closeModal}>×</CloseButton>
              </ModalHeader>
              
              <ModalBody>
                <h3>Biografia</h3>
                <div 
                  className="biography-content"
                  dangerouslySetInnerHTML={{ __html: description || 'Biografia não disponível.' }} 
                />
                
                {professional.courses && professional.courses.length > 0 && (
                  <div className="courses-section">
                    <h3>Aulas nos Módulos</h3>
                    <div className="courses-list">
                      {professional.courses.map((course, index) => (
                        <span key={index} className="course-tag">
                          {course.title.toUpperCase()}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </ModalBody>
            </ModalContent>
          </Modal>
        </ModalOverlay>
      )}
    </>
  );
};

export default CardProfessional;